import { TypeGenerator } from '../utils/type';
import { IArgumentType } from '../functions/utils';
import { InferenceError } from '../errors';
import { IFunctionToken } from '../typings/token';


// 获取事件发生时间
export function EVENT_OCCURRENCE_DATETIME(args: IArgumentType[], token: IFunctionToken) {
  const functionName = token.formatName;

  if (args.length !== 0) {
    throw new InferenceError('function-argument-error', `${functionName} 函数的不接受任何参数`, token.position);
  }


  return TypeGenerator.DateTime();
}
